import React from 'react';
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  withStyles,
  Typography,
} from '@material-ui/core';

import useTranslateText from '../use_translate_text';
import { styles } from './styles';

const Radio_Button = (props) => {
  const { Form_Label, classes, value, name, aria_label, radio_btn_props, setValue, setStateData, stateName,
          radio_per, radio_amt, valueCheck, hideError, wrap, disabled, setRadioValue, column } = props,
        { translateText } = useTranslateText(),
        handleChange = (event) => {
          setValue(event.target.value);
          setStateData && setStateData([stateName], event.target.value);
          event.target.value === valueCheck && radio_amt && setStateData([radio_amt], '')
          || radio_per && setStateData([radio_per], '');
          hideError && hideError(false);
          setRadioValue && setRadioValue(event.target.value);
        };

  return (
    <FormControl component="fieldset">
      <FormLabel component="legend" classes={{ root: classes.formControlLabelRoot, label: classes.formControlLabel }}>
        <Typography variant="span" style={{ color: '#81A7BB' }}>
          {`${translateText(`${Form_Label}`)}`}
        </Typography>
      </FormLabel>
      <RadioGroup
        aria-label={aria_label}
        className={`d-flex ${column || 'flex-row'} ${wrap || 'flex-nowrap'}
          ${translateText(`${Form_Label}`)} ==='Full-Time Student' ?${classes.radioMargin1}: ${classes.radioMargin} `}
        name={name} value={value} onChange={handleChange}
      >
        {radio_btn_props.map((items, i) => {
          const { value, label, labelJsx, lineHeight, info, name } = items;
          return items && <FormControlLabel value={value} key={i} className={`${name || ''}`}
            control={<Radio disabled={disabled} classes={{ root: classes.radio, checked: classes.checked }} />}
            label={
              <Typography variant="span" style={{ color: '#81A7BB', lineHeight: lineHeight }}>
                {(info && <LabelWithInfo {...{ label, info }} />) || `${translateText(`${label}`)}`}
                {labelJsx ? labelJsx : null}
              </Typography>
            }
          />;
        })}
      </RadioGroup>
    </FormControl>
  );
};

const LabelWithInfo = (props) => {
  const { label, info } = props,
        { translateText } = useTranslateText();
  return (<div className="d-flex">
    <div>
      <p className="f14-title">{`${translateText(`${label}`)} `}
        <span className="Forms_Content">{translateText(info)}</span></p>
    </div>
    {/* <div className="w-75 mt-3">
      <p className="Forms_Content">{translateText(info)}</p>
    </div> */}
  </div>

  );
};
export default withStyles(styles)(Radio_Button);